module.exports = __webpack_public_path__ + "static/media/296148.18eb2837.jpg";